module.exports = "<span (click)=\"exportToExcel()\" id=\"btnExportExcel\">\n    <i class=\"fa fa-download\" aria-hidden=\"true\"> Export </i></span>\n"